<template>
    <div class="row">
        <!--Title-->
        <div class="text-right col-md-12">
            <el-tooltip content="Editar" placement="left">
                <p-switch v-model="editSettings" type="primary" >
                    <i class="fa fa-times" slot="on"></i>
                    <i class="fa fa-pencil" slot="off"></i>
                </p-switch>
            </el-tooltip>
            <h4 class="title center-title pull-left">Variables generales del sistema</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.systemSettings.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Add Regional form-->
        <div v-if="!this.$apollo.queries.systemSettings.loading" class="mt-3 col-md-12 card">
            <form>
                <!-- Sección: Parámetros del Sistema -->
                <div class="card-header">
                    <h5 class="card-title">Parámetros del Sistema</h5>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Tiempo de inactividad del sistema</label>
                        <fg-input   ref="idle"
                                    type="number"
                                    name="tiempo"
                                    autocomplete="off"
                                    v-validate="modelValidations.idle"
                                    :error="getError('tiempo')"
                                    v-model="model.idle"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Servidor Ftp</label>
                        <fg-input   ref="ftpHost"
                                    type="text"
                                    name="puerto ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftp"
                                    :error="getError('puerto ftp')"
                                    v-model="model.ftpHost"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Puerto Ftp</label>
                        <fg-input   ref="ftpPort"
                                    type="text"
                                    name="puerto ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftp"
                                    :error="getError('puerto ftp')"
                                    v-model="model.ftpPort"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Usuario Ftp</label>
                        <fg-input   ref="ftpUsername"
                                    type="text"
                                    name="usuario ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftp"
                                    :error="getError('usuario ftp')"
                                    v-model="model.ftpUsername"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Ruta Ftp</label>
                        <fg-input   ref="ftpPath"
                                    type="text"
                                    name="ruta ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftp"
                                    :error="getError('ruta ftp')"
                                    v-model="model.ftpPath"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div v-if="editSettings" class="form-group">
                        <label>¿Cambiar contraseña FTP?</label>
                    </div>
                    <el-tooltip v-if="editSettings" content="Editar" placement="left">
                        <p-switch v-model="editPassword" type="primary" >
                            <i class="fa fa-times" slot="on"></i>
                            <i class="fa fa-pencil" slot="off"></i>
                        </p-switch>
                    </el-tooltip>
                    <div v-show="editPassword && editSettings" class="form-group">
                        <label>Contraseña Ftp</label>
                        <fg-input   ref="ftpPassword"
                                    type="password"
                                    name="contraseña ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftpPassword"
                                    :error="getError('contraseña ftp')"
                                    v-model="model.ftpPassword"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div v-show="editPassword && editSettings" class="form-group">
                        <label>Confirmar contraseña Ftp</label>
                        <fg-input   ref="ftpConfirmPassword"
                                    type="password"
                                    name="confirmar contraseña ftp"
                                    autocomplete="off"
                                    v-validate="modelValidations.ftpConfirmPassword"
                                    :error="getError('confirmar contraseña ftp')"
                                    v-model="model.ftpConfirmPassword"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Max. días - Retoma de evaluaciones</label>
                        <fg-input   ref="daysResume"
                                    type="number"
                                    name="retoma"
                                    autocomplete="off"
                                    v-validate="modelValidations.daysResume"
                                    :error="getError('retoma')"
                                    v-model="model.daysResume"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Alertas y mensajes</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Mensaje"
                                    autocomplete="off"
                                    v-validate="modelValidations.alert"
                                    :error="getError('Mensaje')"
                                    v-model="model.alert"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                </div>

                <!-- Sección: Parametrización Pyme -->
                <div class="card-header">
                    <h5 class="card-title">Parametrización Pyme</h5>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Salario mínimo</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Salario"
                                    autocomplete="off"
                                    v-validate="modelValidations.salary"
                                    :error="getError('Salario')"
                                    v-model="model.salary"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>IPC</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="IPC"
                                    autocomplete="off"
                                    v-validate="modelValidations.ipc"
                                    :error="getError('IPC')"
                                    v-model="model.ipc"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Salud</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Salud"
                                    autocomplete="off"
                                    v-validate="modelValidations.health"
                                    :error="getError('Salud')"
                                    v-model="model.health"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Pensión</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Pensión"
                                    autocomplete="off"
                                    v-validate="modelValidations.pension"
                                    :error="getError('Pensión')"
                                    v-model="model.pension"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>ARL</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="ARL"
                                    autocomplete="off"
                                    v-validate="modelValidations.arl"
                                    :error="getError('ARL')"
                                    v-model="model.arl"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Caja de compensación</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Caja de compensación"
                                    autocomplete="off"
                                    v-validate="modelValidations.compensation"
                                    :error="getError('Caja de compensación')"
                                    v-model="model.compensation"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Intereses de cesantías</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Intereses de cesantías"
                                    autocomplete="off"
                                    v-validate="modelValidations.severancePayInterest"
                                    :error="getError('Intereses de cesantías')"
                                    v-model="model.severancePayInterest"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                </div>

                <!-- Sección: Parámetros Agropecuario -->
                <div class="card-header">
                    <h5 class="card-title">Parametrización Agropecuario</h5>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Edad corte (Simulador Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="edad de corte"
                                    autocomplete="off"
                                    v-validate="modelValidations.ageForAssurance"
                                    :error="getError('edad de corte')"
                                    v-model="model.ageForAssurance"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Porcentaje de seguro por debajo de la edad de corte (Simulador Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Porcentaje por debajo"
                                    autocomplete="off"
                                    v-validate="modelValidations.ageForAssurancePercentBelow"
                                    :error="getError('Porcentaje por debajo')"
                                    v-model="model.ageForAssurancePercentBelow"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Porcentaje de seguro por encima de la edad de corte (Simulador Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Porcentaje por encima"
                                    autocomplete="off"
                                    v-validate="modelValidations.ageForAssurancePercentAbove"
                                    :error="getError('Porcentaje por encima')"
                                    v-model="model.ageForAssurancePercentAbove"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                </div>

                <!-- Sección: Parametrización Cupo de Crédito Rotativo -->
                <div class="card-header">
                    <h5 class="card-title">Parametrización Cupo de Crédito Rotativo</h5>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Porcentaje monto máximo cupo crédito (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Porcentaje monto máximo cupo crédito Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountPercentMicro"
                                    :error="getError('Porcentaje monto máximo cupo crédito Microcrédito')"
                                    v-model="model.creditLineMaxAmountPercentMicro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto mínimo cupo crédito (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto mínimo cupo crédito Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMinAmountMicro"
                                    :error="getError('Monto mínimo cupo crédito Microcrédito')"
                                    v-model="model.creditLineMinAmountMicro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto máximo cupo crédito (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto máximo cupo crédito Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountMicro"
                                    :error="getError('Monto máximo cupo crédito Microcrédito')"
                                    v-model="model.creditLineMaxAmountMicro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Destino del crédito en cupo de crédito rotativo (Microcrédito)</label>
                        <fg-input name="rol">
                            <el-select class="select-warning"
                                        name="Destino del crédito en cupo de crédito rotativo Microcrédito"
                                        size="large"
                                        placeholder="Seleccione Destino del crédito en cupo de crédito rotativo Microcrédito"
                                        v-validate="'required'"
                                        :error="errors.has('Destino del crédito en cupo de crédito rotativo Microcrédito')"
                                        v-model="model.creditLineDestinationMicro"
                                        :disabled="!editSettings">
                                <el-option
                                        v-for="purpose in creditPurposes_array"
                                        :key="purpose.id"
                                        class="select-warning"
                                        :value="purpose.id"
                                        :label="purpose.name">
                                </el-option>
                            </el-select>
                            <span v-show="errors.has('Destino del crédito en cupo de crédito rotativo Microcrédito')" class="text-danger">{{ errors.first('Destino del crédito en cupo de crédito rotativo Microcrédito') }}</span>
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Número de Cuotas - FM102 (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Número de Cuotas FM102 Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineQuotaQtyMicro"
                                    :error="getError('Número de Cuotas FM102 Microcrédito')"
                                    v-model="model.creditLineQuotaQtyMicro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 1 al 10 (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 1 al 10 Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange1Micro"
                                    :error="getError('Fecha de corte 1 al 10 Microcrédito')"
                                    v-model="model.creditLineStatementDateRange1Micro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 11 al 20 (Microcrédito)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 11 al 20 Microcrédito"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange2Micro"
                                    :error="getError('Fecha de corte 11 al 20 Microcrédito')"
                                    v-model="model.creditLineStatementDateRange2Micro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Porcentaje monto máximo cupo crédito (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Porcentaje monto máximo cupo crédito Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountPercentPyme"
                                    :error="getError('Porcentaje monto máximo cupo crédito Pyme')"
                                    v-model="model.creditLineMaxAmountPercentPyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto mínimo cupo crédito (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto mínimo cupo crédito Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMinAmountPyme"
                                    :error="getError('Monto mínimo cupo crédito Pyme')"
                                    v-model="model.creditLineMinAmountPyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto máximo cupo crédito (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto máximo cupo crédito Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountPyme"
                                    :error="getError('Monto máximo cupo crédito Pyme')"
                                    v-model="model.creditLineMaxAmountPyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Destino del crédito en cupo de crédito rotativo (Pyme)</label>
                        <fg-input name="rol">
                            <el-select class="select-warning"
                                        name="Destino del crédito en cupo de crédito rotativo Pyme"
                                        size="large"
                                        placeholder="Seleccione Destino del crédito en cupo de crédito rotativo Pyme"
                                        v-validate="'required'"
                                        :error="errors.has('Destino del crédito en cupo de crédito rotativo Pyme')"
                                        v-model="model.creditLineDestinationPyme"
                                        :disabled="!editSettings">
                                <el-option
                                        v-for="purpose in creditPurposes_array"
                                        :key="purpose.id"
                                        class="select-warning"
                                        :value="purpose.id"
                                        :label="purpose.name">
                                </el-option>
                            </el-select>
                            <span v-show="errors.has('Destino del crédito en cupo de crédito rotativo Pyme')" class="text-danger">{{ errors.first('Destino del crédito en cupo de crédito rotativo Pyme') }}</span>
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Número de Cuotas - FM102 (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Número de Cuotas FM102 Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineQuotaQtyPyme"
                                    :error="getError('Número de Cuotas FM102 Pyme')"
                                    v-model="model.creditLineQuotaQtyPyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 1 al 10 (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 1 al 10 Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange1Pyme"
                                    :error="getError('Fecha de corte 1 al 10 Pyme')"
                                    v-model="model.creditLineStatementDateRange1Pyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 11 al 20 (Pyme)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 11 al 20 Pyme"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange2Pyme"
                                    :error="getError('Fecha de corte 11 al 20 Pyme')"
                                    v-model="model.creditLineStatementDateRange2Pyme"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Porcentaje monto máximo cupo crédito (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Porcentaje monto máximo cupo crédito Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountPercentAgro"
                                    :error="getError('Porcentaje monto máximo cupo crédito Agro')"
                                    v-model="model.creditLineMaxAmountPercentAgro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto mínimo cupo crédito (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto mínimo cupo crédito Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMinAmountAgro"
                                    :error="getError('Monto mínimo cupo crédito Agro')"
                                    v-model="model.creditLineMinAmountAgro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Monto máximo cupo crédito (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="text"
                                    name="Monto máximo cupo crédito Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineMaxAmountAgro"
                                    :error="getError('Monto máximo cupo crédito Agro')"
                                    v-model="model.creditLineMaxAmountAgro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Destino del crédito en cupo de crédito rotativo (Agro)</label>
                        <fg-input name="rol">
                            <el-select class="select-warning"
                                        name="Destino del crédito en cupo de crédito rotativo Agro"
                                        size="large"
                                        placeholder="Seleccione Destino del crédito en cupo de crédito rotativo Agro"
                                        v-validate="'required'"
                                        :error="errors.has('Destino del crédito en cupo de crédito rotativo Agro')"
                                        v-model="model.creditLineDestinationAgro"
                                        :disabled="!editSettings">
                                <el-option
                                        v-for="purpose in creditPurposes_array"
                                        :key="purpose.id"
                                        class="select-warning"
                                        :value="purpose.id"
                                        :label="purpose.name">
                                </el-option>
                            </el-select>
                            <span v-show="errors.has('Destino del crédito en cupo de crédito rotativo Agro')" class="text-danger">{{ errors.first('Destino del crédito en cupo de crédito rotativo Agro') }}</span>
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Número de Cuotas - FM102 (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Número de Cuotas FM102 Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineQuotaQtyAgro"
                                    :error="getError('Número de Cuotas FM102 Agro')"
                                    v-model="model.creditLineQuotaQtyAgro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 1 al 10 (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 1 al 10 Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange1Agro"
                                    :error="getError('Fecha de corte 1 al 10 Agro')"
                                    v-model="model.creditLineStatementDateRange1Agro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte - 11 al 20 (Agro)</label>
                        <fg-input   ref="messageAlert"
                                    type="number"
                                    name="Fecha de corte 11 al 20 Agro"
                                    autocomplete="off"
                                    v-validate="modelValidations.creditLineStatementDateRange2Agro"
                                    :error="getError('Fecha de corte 11 al 20 Agro')"
                                    v-model="model.creditLineStatementDateRange2Agro"
                                    :disabled="!editSettings">
                        </fg-input>
                    </div>
                </div>
                <div class="card-footer">
                    <div v-show="editSettings" class="text-right">
                        <p-button type="success" @click.prevent="validate">Aceptar</p-button>
                    </div>
                </div>
            </form>
        </div>
        <!--./Add Regional form-->
    </div>
</template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { systemSettings } from 'src/api/graphql/queries/setup/AllSettings';
    import { creditPurposes } from 'src/api/graphql/queries/setup/AllCreditPurposes';
    import { EDIT_SETTINGS } from 'src/api/graphql/mutations/setup/EditSettings';
    import { orderBy , sortBy , find } from 'lodash';
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        systemSettings: {
                    query: systemSettings,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        if(data.systemSettings.length == 0)
                        {
                            this.systemSettings_array = [];
                        }
                        else
                        {
                            this.setSystemSettings(data.systemSettings);
                            this.$apollo.queries.systemSettings.skip = true;
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
                creditPurposes: {
                    query: creditPurposes,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {

                        if(data.creditPurposes.edges.length == 0)
                        {
                            this.creditPurposes_array = [];
                        }
                        else
                        {
                            this.setCreditPurposes(data.creditPurposes);
                            this.$apollo.queries.creditPurposes.skip = true;
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                }
        },
        components: {
        PSwitch,
        Loading,
        [Tooltip.name]: Tooltip
        },
        watch: {
            /***
            * Función que tiene vigilada la variable editSettings y poder activar el autofoco
            */
            editSettings: function(val){
                if(val){
                    var vm = this;
                    vm.$refs.idle.$el.children[0].focus();//Asignamos focus en el campo
                }
            }
        },
        computed: {
        },
        data () {
        return {
            editSettings: false,
            editPassword: false,
            isSending: false,
            fullPage: false,
            systemSettings_array : [],
            creditPurposes_array : [],
            rowEdit: {},

            model: {
                idle: 0,
                ftpHost: '',
                ftpPort: '',
                ftpUsername: '',
                ftpPassword: '',
                ftpConfirmPassword: '',
                ftpPath: '',
                daysResume: 0,
                alert: '',
                salary: 0,
                ipc: 0,
                health: null,
                pension: null,
                arl: null,
                compensation: null,
                severancePayInterest: null,
                ageForAssurance: null,
                ageForAssurancePercentBelow: null,
                ageForAssurancePercentAbove: null,
                creditLineMinAmountMicro: null,
                creditLineMaxAmountMicro: null,
                creditLineMaxAmountPercentMicro: null,
                creditLineDestinationMicro: null,
                creditLineQuotaQtyMicro: null,
                creditLineStatementDateRange1Micro: null,
                creditLineStatementDateRange2Micro: null,
                creditLineMinAmountPyme: null,
                creditLineMaxAmountPyme: null,
                creditLineMaxAmountPercentPyme: null,
                creditLineDestinationPyme: null,
                creditLineQuotaQtyPyme: null,
                creditLineStatementDateRange1Pyme: null,
                creditLineStatementDateRange2Pyme: null,
                creditLineMinAmountAgro: null,
                creditLineMaxAmountAgro: null,
                creditLineMaxAmountPercentAgro: null,
                creditLineDestinationAgro: null,
                creditLineQuotaQtyAgro: null,
                creditLineStatementDateRange1Agro: null,
                creditLineStatementDateRange2Agro: null
            },
            modelValidations: {
                idle: {
                    numeric: true,
                    required: true,
                    max: 8
                },
                ftp: {
                    required: true,
                    max: 64
                },
                ftpPassword: {
                    max: 64,
                    min: 8
                },
                ftpConfirmPassword: {
                    max: 64,
                    min: 8,
                    confirmed: 'ftpPassword'
                },
                alert: {
                    max: 128,
                    min: 8
                },
                salary: {
                    max: 32,
                    min: 7
                },
                ipc: {
                    decimal: 4
                },
                health: {
                    decimal: 1
                },
                pension: {
                    decimal: 1
                },
                arl: {
                    decimal: 3
                },
                compensation: {
                    decimal: 1
                },
                severancePayInterest: {
                    decimal: 1
                },
                ageForAssurance: {
                    numeric: true,
                    between:[18,99]
                },
                ageForAssurancePercentBelow: {
                    decimal: 4
                },
                ageForAssurancePercentAbove: {
                    decimal: 4
                },
                creditLineMaxAmountPercentMicro: {
                    numeric: true,
                    between:[1,100]
                },
                creditLineMinAmountMicro: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineMaxAmountMicro: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineDestinationMicro: {
                    max: 128
                },
                creditLineStatementDateRange1Micro: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineStatementDateRange2Micro: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineQuotaQtyMicro: {
                    numeric: true,
                    min_value:1,
                    max_value:99
                },
                creditLineMaxAmountPercentPyme: {
                    numeric: true,
                    between:[1,100]
                },
                creditLineMinAmountPyme: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineMaxAmountPyme: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineDestinationPyme: {
                    max: 128
                },
                creditLineStatementDateRange1Pyme: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineStatementDateRange2Pyme: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineQuotaQtyPyme: {
                    numeric: true,
                    min_value:1,
                    max_value:99
                },
                creditLineMaxAmountPercentAgro: {
                    numeric: true,
                    between:[1,100]
                },
                creditLineMinAmountAgro: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineMaxAmountAgro: {
                    numeric: true,
                    min_value:1,
                    max_value:999999999999999
                },
                creditLineDestinationAgro: {
                    max: 128
                },
                creditLineStatementDateRange1Agro: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineStatementDateRange2Agro: {
                    numeric: true,
                    between:[1,31]
                },
                creditLineQuotaQtyAgro: {
                    numeric: true,
                    min_value:1,
                    max_value:99
                },
            },
        }
        },
        methods: {
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setSystemSettings(systemSettings){
                var vm = this;
                vm.model.idle = systemSettings.idleTime;
                vm.model.ftpHost = systemSettings.ftpHost;
                vm.model.ftpPort = systemSettings.ftpPort;
                vm.model.ftpUsername = systemSettings.ftpUsername;
                vm.model.ftpPath = systemSettings.ftpPath;
                vm.model.daysResume = systemSettings.daysResume;
                vm.model.alert = systemSettings.alert;
                vm.model.salary = systemSettings.salary;
                vm.model.ipc = systemSettings.ipc;
                vm.model.health = systemSettings.health;
                vm.model.pension = systemSettings.pension;
                vm.model.arl = systemSettings.arl;
                vm.model.compensation = systemSettings.compensation;
                vm.model.severancePayInterest = systemSettings.severancePayInterest;
                vm.model.ageForAssurance = systemSettings.ageForAssurance;
                vm.model.ageForAssurancePercentBelow = systemSettings.ageForAssurancePercentBelow;
                vm.model.ageForAssurancePercentAbove = systemSettings.ageForAssurancePercentAbove;
                vm.model.creditLineMinAmountMicro = systemSettings.creditLineMinAmountMicro;
                vm.model.creditLineMaxAmountMicro = systemSettings.creditLineMaxAmountMicro;
                vm.model.creditLineMaxAmountPercentMicro = systemSettings.creditLineMaxAmountPercentMicro;
                vm.model.creditLineDestinationMicro = systemSettings.creditLineDestinationMicro;
                vm.model.creditLineQuotaQtyMicro = systemSettings.creditLineQuotaQtyMicro;
                vm.model.creditLineStatementDateRange1Micro = systemSettings.creditLineStatementDateRange1Micro;
                vm.model.creditLineStatementDateRange2Micro = systemSettings.creditLineStatementDateRange2Micro;
                vm.model.creditLineMinAmountPyme = systemSettings.creditLineMinAmountPyme;
                vm.model.creditLineMaxAmountPyme = systemSettings.creditLineMaxAmountPyme;
                vm.model.creditLineMaxAmountPercentPyme = systemSettings.creditLineMaxAmountPercentPyme;
                vm.model.creditLineDestinationPyme = systemSettings.creditLineDestinationPyme;
                vm.model.creditLineQuotaQtyPyme = systemSettings.creditLineQuotaQtyPyme;
                vm.model.creditLineStatementDateRange1Pyme = systemSettings.creditLineStatementDateRange1Pyme;
                vm.model.creditLineStatementDateRange2Pyme = systemSettings.creditLineStatementDateRange2Pyme;
                vm.model.creditLineMinAmountAgro = systemSettings.creditLineMinAmountAgro;
                vm.model.creditLineMaxAmountAgro = systemSettings.creditLineMaxAmountAgro;
                vm.model.creditLineMaxAmountPercentAgro = systemSettings.creditLineMaxAmountPercentAgro;
                vm.model.creditLineDestinationAgro = systemSettings.creditLineDestinationAgro;
                vm.model.creditLineQuotaQtyAgro = systemSettings.creditLineQuotaQtyAgro;
                vm.model.creditLineStatementDateRange1Agro = systemSettings.creditLineStatementDateRange1Agro;
                vm.model.creditLineStatementDateRange2Agro = systemSettings.creditLineStatementDateRange2Agro;
            },
            setCreditPurposes(creditPurposes){
                var vm = this;
                for(let i=0;i<creditPurposes.edges.length;i++)
                {
                    vm.pushData(creditPurposes.edges[i].node);
                }
            },
            pushData(node){
                var vm = this;
                if(node.isActive){
                    vm.creditPurposes_array.push({
                        id: node.id,
                        code: node.code,
                        name: node.name,
                        isActive: node.isActive,
                    });
                }
            },
            /***
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
                if(isLoading == true || isSending == true){
                    return true
                }
                else{
                    return false
                }
            },
            /**
            * Función que pone el foco en el campo de code
            */
            focusFirstField(){
            this.$refs.idle.$el.children[0].focus();//Asignamos focus en el campo
            },
            /***
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    vm.isSending = true;
                    // Iniciamos el envío de la mutación
                    var localInput = {};
                    if (vm.model.ftpPassword != '') {
                        localInput.idleTime =  vm.model.idle,
                        localInput.ftpHost =  vm.model.ftpHost,
                        localInput.ftpPort =  vm.model.ftpPort,
                        localInput.ftpPassword = vm.model.ftpPassword,
                        localInput.ftpUsername =  vm.model.ftpUsername,
                        localInput.ftpPath =  vm.model.ftpPath,
                        localInput.daysResume =  vm.model.daysResume,
                        localInput.alert =  vm.model.alert
                        localInput.salary =  vm.model.salary
                        localInput.ipc =  vm.model.ipc,
                        localInput.health = vm.model.health,
                        localInput.pension = vm.model.pension,
                        localInput.arl = vm.model.arl,
                        localInput.compensation = vm.model.compensation,
                        localInput.severancePayInterest = vm.model.severancePayInterest,
                        localInput.ageForAssurance = vm.model.ageForAssurance,
                        localInput.ageForAssurancePercentBelow = vm.model.ageForAssurancePercentBelow,
                        localInput.ageForAssurancePercentAbove = vm.model.ageForAssurancePercentAbove,
                        localInput.creditLineMinAmountMicro = vm.model.creditLineMinAmountMicro,
                        localInput.creditLineMaxAmountMicro = vm.model.creditLineMaxAmountMicro,
                        localInput.creditLineMaxAmountPercentMicro = vm.model.creditLineMaxAmountPercentMicro,
                        localInput.creditLineDestinationMicro = vm.model.creditLineDestinationMicro,
                        localInput.creditLineQuotaQtyMicro = vm.model.creditLineQuotaQtyMicro,
                        localInput.creditLineStatementDateRange1Micro = vm.model.creditLineStatementDateRange1Micro,
                        localInput.creditLineStatementDateRange2Micro = vm.model.creditLineStatementDateRange2Micro,
                        localInput.creditLineMinAmountPyme = vm.model.creditLineMinAmountPyme,
                        localInput.creditLineMaxAmountPyme = vm.model.creditLineMaxAmountPyme,
                        localInput.creditLineMaxAmountPercentPyme = vm.model.creditLineMaxAmountPercentPyme,
                        localInput.creditLineDestinationPyme = vm.model.creditLineDestinationPyme,
                        localInput.creditLineQuotaQtyPyme = vm.model.creditLineQuotaQtyPyme,
                        localInput.creditLineStatementDateRange1Pyme = vm.model.creditLineStatementDateRange1Pyme,
                        localInput.creditLineStatementDateRange2Pyme = vm.model.creditLineStatementDateRange2Pyme,
                        localInput.creditLineMinAmountAgro = vm.model.creditLineMinAmountAgro,
                        localInput.creditLineMaxAmountAgro = vm.model.creditLineMaxAmountAgro,
                        localInput.creditLineMaxAmountPercentAgro = vm.model.creditLineMaxAmountPercentAgro,
                        localInput.creditLineDestinationAgro = vm.model.creditLineDestinationAgro,
                        localInput.creditLineQuotaQtyAgro = vm.model.creditLineQuotaQtyAgro,
                        localInput.creditLineStatementDateRange1Agro = vm.model.creditLineStatementDateRange1Agro,
                        localInput.creditLineStatementDateRange2Agro = vm.model.creditLineStatementDateRange2Agro
                    }
                    else {
                        localInput.idleTime =  vm.model.idle,
                        localInput.ftpHost =  vm.model.ftpHost,
                        localInput.ftpPort =  vm.model.ftpPort,
                        localInput.ftpUsername =  vm.model.ftpUsername,
                        localInput.ftpPath =  vm.model.ftpPath,
                        localInput.daysResume =  vm.model.daysResume,
                        localInput.alert =  vm.model.alert
                        localInput.salary =  vm.model.salary
                        localInput.ipc =  vm.model.ipc,
                        localInput.health = vm.model.health,
                        localInput.pension = vm.model.pension,
                        localInput.arl = vm.model.arl,
                        localInput.compensation = vm.model.compensation,
                        localInput.severancePayInterest = vm.model.severancePayInterest,
                        localInput.ageForAssurance = vm.model.ageForAssurance,
                        localInput.ageForAssurancePercentBelow = vm.model.ageForAssurancePercentBelow,
                        localInput.ageForAssurancePercentAbove = vm.model.ageForAssurancePercentAbove,
                        localInput.creditLineMinAmountMicro = vm.model.creditLineMinAmountMicro,
                        localInput.creditLineMaxAmountMicro = vm.model.creditLineMaxAmountMicro,
                        localInput.creditLineMaxAmountPercentMicro = vm.model.creditLineMaxAmountPercentMicro,
                        localInput.creditLineDestinationMicro = vm.model.creditLineDestinationMicro,
                        localInput.creditLineQuotaQtyMicro = vm.model.creditLineQuotaQtyMicro,
                        localInput.creditLineStatementDateRange1Micro = vm.model.creditLineStatementDateRange1Micro,
                        localInput.creditLineStatementDateRange2Micro = vm.model.creditLineStatementDateRange2Micro,
                        localInput.creditLineMinAmountPyme = vm.model.creditLineMinAmountPyme,
                        localInput.creditLineMaxAmountPyme = vm.model.creditLineMaxAmountPyme,
                        localInput.creditLineMaxAmountPercentPyme = vm.model.creditLineMaxAmountPercentPyme,
                        localInput.creditLineDestinationPyme = vm.model.creditLineDestinationPyme,
                        localInput.creditLineQuotaQtyPyme = vm.model.creditLineQuotaQtyPyme,
                        localInput.creditLineStatementDateRange1Pyme = vm.model.creditLineStatementDateRange1Pyme,
                        localInput.creditLineStatementDateRange2Pyme = vm.model.creditLineStatementDateRange2Pyme,
                        localInput.creditLineMinAmountAgro = vm.model.creditLineMinAmountAgro,
                        localInput.creditLineMaxAmountAgro = vm.model.creditLineMaxAmountAgro,
                        localInput.creditLineMaxAmountPercentAgro = vm.model.creditLineMaxAmountPercentAgro,
                        localInput.creditLineDestinationAgro = vm.model.creditLineDestinationAgro,
                        localInput.creditLineQuotaQtyAgro = vm.model.creditLineQuotaQtyAgro,
                        localInput.creditLineStatementDateRange1Agro = vm.model.creditLineStatementDateRange1Agro,
                        localInput.creditLineStatementDateRange2Agro = vm.model.creditLineStatementDateRange2Agro
                    }
                    this.$apollo.mutate({
                        mutation: EDIT_SETTINGS,
                        variables : {
                            input : localInput
                        }
                    }).then((data) => {
                        vm.model.idle = data.data.systemSettings.systemSettings.idleTime;
                        vm.model.ftpHost = data.data.systemSettings.systemSettings.ftpHost;
                        vm.model.ftpPort = data.data.systemSettings.systemSettings.ftpPort;
                        vm.model.ftpUsername = data.data.systemSettings.systemSettings.ftpUsername;
                        vm.model.ftpPath = data.data.systemSettings.systemSettings.ftpPath;
                        vm.model.daysResume = data.data.systemSettings.systemSettings.daysResume;
                        vm.model.alert = data.data.systemSettings.systemSettings.alert;
                        vm.model.salary = data.data.systemSettings.systemSettings.salary;
                        vm.model.ipc = data.data.systemSettings.systemSettings.ipc;
                        vm.model.health = data.data.systemSettings.systemSettings.health;
                        vm.model.pension = data.data.systemSettings.systemSettings.pension;
                        vm.model.arl = data.data.systemSettings.systemSettings.arl;
                        vm.model.compensation = data.data.systemSettings.systemSettings.compensation;
                        vm.model.severancePayInterest = data.data.systemSettings.systemSettings.severancePayInterest;
                        vm.model.ageForAssurance = data.data.systemSettings.systemSettings.ageForAssurance;
                        vm.model.ageForAssurancePercentBelow = data.data.systemSettings.systemSettings.ageForAssurancePercentBelow;
                        vm.model.ageForAssurancePercentAbove = data.data.systemSettings.systemSettings.ageForAssurancePercentAbove;
                        vm.model.creditLineMinAmountMicro = data.data.systemSettings.systemSettings.creditLineMinAmountMicro;
                        vm.model.creditLineMaxAmountMicro = data.data.systemSettings.systemSettings.creditLineMaxAmountMicro;
                        vm.model.creditLineMaxAmountPercentMicro = data.data.systemSettings.systemSettings.creditLineMaxAmountPercentMicro;
                        vm.model.creditLineDestinationMicro = data.data.systemSettings.systemSettings.creditLineDestinationMicro;
                        vm.model.creditLineQuotaQtyMicro = data.data.systemSettings.systemSettings.creditLineQuotaQtyMicro;
                        vm.model.creditLineStatementDateRange1Micro = data.data.systemSettings.systemSettings.creditLineStatementDateRange1Micro;
                        vm.model.creditLineStatementDateRange2Micro = data.data.systemSettings.systemSettings.creditLineStatementDateRange2Micro;
                        vm.model.creditLineMinAmountPyme = data.data.systemSettings.systemSettings.creditLineMinAmountPyme;
                        vm.model.creditLineMaxAmountPyme = data.data.systemSettings.systemSettings.creditLineMaxAmountPyme;
                        vm.model.creditLineMaxAmountPercentPyme = data.data.systemSettings.systemSettings.creditLineMaxAmountPercentPyme;
                        vm.model.creditLineDestinationPyme = data.data.systemSettings.systemSettings.creditLineDestinationPyme;
                        vm.model.creditLineQuotaQtyPyme = data.data.systemSettings.systemSettings.creditLineQuotaQtyPyme;
                        vm.model.creditLineStatementDateRange1Pyme = data.data.systemSettings.systemSettings.creditLineStatementDateRange1Pyme;
                        vm.model.creditLineStatementDateRange2Pyme = data.data.systemSettings.systemSettings.creditLineStatementDateRange2Pyme;
                        vm.model.creditLineMinAmountAgro = data.data.systemSettings.systemSettings.creditLineMinAmountAgro;
                        vm.model.creditLineMaxAmountAgro = data.data.systemSettings.systemSettings.creditLineMaxAmountAgro;
                        vm.model.creditLineMaxAmountPercentAgro = data.data.systemSettings.systemSettings.creditLineMaxAmountPercentAgro;
                        vm.model.creditLineDestinationAgro = data.data.systemSettings.systemSettings.creditLineDestinationAgro;
                        vm.model.creditLineQuotaQtyAgro = data.data.systemSettings.systemSettings.creditLineQuotaQtyAgro;
                        vm.model.creditLineStatementDateRange1Agro = data.data.systemSettings.systemSettings.creditLineStatementDateRange1Agro;
                        vm.model.creditLineStatementDateRange2Agro = data.data.systemSettings.systemSettings.creditLineStatementDateRange2Agro;
                        vm.model.ftpPassword = '';
                        vm.model.ftpConfirmPassword = '';
                        vm.editPassword = false;
                        vm.isSending = false;
                        vm.editSettings = false;
                        // vm.onSuccess('Variables editadas con éxito. No olvides modificar el archivo de configuración con la versión: '+data.data.systemSettings.systemSettings.versionId);
                        vm.onSuccess('Variables editadas con éxito');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                })
        }
        },
        mounted() {
        }
    }
    </script>
    <style lang="scss">
</style>
